import apiFetch from '../apiFetch'

export default function (token, body, fleetId, reason) {
  const queryParamsArray = [
    fleetId ? `fleetId=${fleetId}` : null,
    reason ? `reason=${reason}` : null
  ]

  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({ endPoint: `UnattendedProcess/SetRejectDocumentFleet${queryParams}`, method: 'POST', body: body, token: token })
}
